import { render, staticRenderFns } from "./TrademarkForm.vue?vue&type=template&id=7b14610f&"
import script from "./TrademarkForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkForm.vue?vue&type=style&index=0&id=7b14610f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports